<template>
    <div class="declaration-management">
      <el-row :gutter="20">
        <!-- 左侧筛选和列表 -->
        <el-col :span="16">
          <el-card class="box-card">
            <h2>公司账期申报管理</h2>
  
            <!-- 筛选表单 -->
            <el-form :model="form" label-width="120px" class="form">
              <!-- 选择公司 -->
              <el-form-item label="选择公司">
                <el-select v-model="form.compay_id" placeholder="请选择公司"

                 filterable 
                clearable>
                  <el-option
                    v-for="company in companyList"
                    :key="company.compay_id"
                    :label="company.name"
                    :value="company.compay_id"
                  />
                </el-select>
              </el-form-item>
  
              <!-- 选择年份 -->
              <el-form-item label="选择年份">
                <el-select v-model="form.year" placeholder="请选择年份" @change="fetchPeriods">
                  <el-option
                    v-for="year in yearList"
                    :key="year"
                    :label="year"
                    :value="year"
                  />
                </el-select>
              </el-form-item>
            </el-form>
  
            <!-- 账期列表 -->
            <el-table :data="periodList" style="width: 100%" height="400" @row-click="onRowClick">
              <el-table-column prop="month" label="账期" width="150" />
                <el-table-column prop="is_submitted" label="提交状态" width="150" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_submitted == 0">未提交</span>
                        <span v-if="scope.row.is_submitted == 1">已提交</span>
                    </template>
                </el-table-column>
                <el-table-column prop="is_submitted" label="审核状态" width="150" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_approved == 0">未审核</span>
                        <span v-if="scope.row.is_approved == 1">已通过</span>
                        <span v-if="scope.row.is_approved == 2">不通过</span>
                    </template>
                </el-table-column>
              <el-table-column prop="sub_time" label="提交时间" />
            </el-table>
          </el-card>
        </el-col>
  
        <!-- 右侧操作区域 -->
        <el-col :span="8">
          <el-card class="box-card">
            <h3>账期详情与操作</h3>
  
            <!-- 账期信息 -->
            <el-descriptions title="账期信息" :column="1" v-if="selectedPeriod">
              <el-descriptions-item label="账期">{{ selectedPeriod.month }}</el-descriptions-item>
              <el-descriptions-item label="提交状态">
                <span v-if="selectedPeriod.is_submitted == 0">未提交</span>
                <span v-if="selectedPeriod.is_submitted == 1">已提交</span>

              </el-descriptions-item>
              <el-descriptions-item label="审核状态">
  
                <span v-if="selectedPeriod.is_approved == 0">未审核</span>
                <span v-if="selectedPeriod.is_approved == 1">已通过</span>
                <span v-if="selectedPeriod.is_approved == 2">不通过</span>

              </el-descriptions-item>
              <el-descriptions-item label="提交时间">{{ selectedPeriod.sub_time || '未提交' }}</el-descriptions-item>
            </el-descriptions>
  
            <!-- 查看详情 -->
            <el-button type="primary" @click="viewDetails" style="margin-bottom: 20px;">查看详情</el-button>
  
            <!-- 审核操作 -->
            <el-divider />
            <div v-if="selectedPeriod">
                <el-button v-if="selectedPeriod.is_approved == 0" type="success" @click="approvePeriod"
             :disabled="!selectedPeriod">申报通过</el-button>
            <el-button v-if="selectedPeriod.is_approved == 0" type="danger"
             @click="openRejectDialog" :disabled="!selectedPeriod">申报驳回</el-button>
            </div>
        
          </el-card>
        </el-col>
      </el-row>
  
      <!-- 详情对话框 -->
      <el-dialog title="账期详情" :visible.sync="detailsVisible" width="60%">
        <el-tabs>
          <!-- 员工列表 -->
          <el-tab-pane label="员工列表">
            <el-table :data="employeeList" style="width: 100%">
              <el-table-column prop="service_staff.name" label="姓名" />
              <el-table-column prop="service_staff.age" label="年龄" />
              <el-table-column prop="service_staff.gender" label="性别" >
                <template slot-scope="scope">
                        <span v-if="scope.row.service_staff.gender == 1">男</span>
                        <span v-if="scope.row.service_staff.gender == 0">女</span>
                    </template>
              </el-table-column>
              <el-table-column prop="service_staff.id_card_number" label="身份证" />
              <el-table-column prop="service_staff.salary_amount" label="工资" />
              <el-table-column prop="service_staff.position" label="职位" />

              
            </el-table>
          </el-tab-pane>
  
          <!-- 工资表 -->
          <el-tab-pane label="工资表">
            <el-table :data="salaryList" style="width: 100%">
              <el-table-column prop="file_name" label="文件名称" />
              <el-table-column prop="total_salary" label="操作" >
                <template slot-scope="scope">
                      <a style="color:blue;" @click="open(scope.row.file_path)">打开</a>
                    </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
  
          <!-- 银行流水 -->
          <el-tab-pane label="银行流水">
            <el-table :data="bankFlowList" style="width: 100%">
            <el-table-column prop="file_name" label="文件名称" />
              <el-table-column prop="total_salary" label="操作" >
                <template slot-scope="scope">
                      <a style="color:blue;" @click="open(scope.row.file_path)">打开</a>
                    </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
          <el-button @click="detailsVisible = false">关闭</el-button>
        </span>
      </el-dialog>



         <!-- 审核驳回理由对话框 -->
         <el-dialog title="审核驳回" :visible.sync="rejectDialogVisible" width="30%">
            <el-form>
                <el-form-item label="驳回理由" label-width="400">
                    <el-input v-model="rejectReason" type="textarea" placeholder="请输入驳回理由"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="rejectDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="confirmReject">确认驳回</el-button>
            </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
    import CompayApi from '@/api/compay.js';
  export default {
    data() {
      return {
        loading:false,
        // 筛选表单
        form: {
          compay_id: null, // 选中的公司 ID
          year: null, // 选中的年份
        },
        companyList: [], // 公司列表
        yearList: [], // 年份列表
        periodList: [], // 账期列表
        selectedPeriod: null, // 选中的账期
  
        // 详情数据
        detailsVisible: false, // 详情弹窗显示状态
        employeeList: [], // 员工列表
        salaryList: [], // 工资表
        bankFlowList: [], // 银行流水

        rejectDialogVisible: false,
        rejectReason: '', // 驳回理由
      };
    },
    created() {
      this.fetchCompanies(); // 初始化公司列表
      this.fetchYears(); // 初始化年份列表
    },
    methods: {
        open(url){
            window.open(url, "_blank");
        },
      // 获取公司列表
      fetchCompanies() {
        let self = this;
        let Params = this.form;

        self.loading = true;
        CompayApi.lista(Params, true)
          .then(data => {
            self.loading = false;
            self.companyList = data.data;
          })
          .catch(error => {
          });

      },
  
      // 初始化年份
      fetchYears() {
        const currentYear = new Date().getFullYear();
        for (let year = currentYear - 10; year <= currentYear; year++) {
          this.yearList.push(year);
        }
      },
  
      // 获取账期列表
      fetchPeriods() {

        let self = this;
        self.loading = true;
        CompayApi.getPeriodsByYear({ compay_id: this.form.compay_id, year: this.form.year }, true)
          .then(data => {
            self.loading = false;
            console.log('data',data)
            self.periodList = data.data;
          })
          .catch(error => {
          });
      },
  
      // 行点击事件
      onRowClick(row) {
        this.selectedPeriod = row;
      },
  
      // 查看详情
      viewDetails() {
        if (!this.selectedPeriod) {
          this.$message.error("请先选择一个账期");
          return;
        }
        this.detailsVisible = true;
  
        // 获取详情数据

        let self = this;
        self.loading = true;
        CompayApi.getDetailsByPeriod({ declaration_id:this.selectedPeriod.declaration_id }, true)
          .then(data => {
            self.loading = false;
            self.employeeList = data.data.employees || [];
            self.salaryList = data.data.salaries || [];
            self.bankFlowList = data.data.bank_flows || [];
          })
          .catch(error => {
          });

      },
  
      // 审核通过
      approvePeriod() {
        if (!this.selectedPeriod) return;


        
        let self = this;
        self.loading = true;
        CompayApi.approvePeriod({ declaration_id:this.selectedPeriod.declaration_id }, true)
          .then(data => {
            this.$message.success("审核通过");
            this.selectedPeriod = null
            this.fetchPeriods(); // 刷新账期列表
          })
          .catch(error => {
          });
      },
      openRejectDialog() {
            this.rejectDialogVisible = true;
        },
        confirmReject() {
            if (!this.rejectReason.trim()) {
                this.$message.error('请输入驳回理由');
                return;
            }
            let self = this;
            self.loading = true;
            CompayApi.rejectPeriod({ 
                declaration_id: this.selectedPeriod.declaration_id, 
                reject_val: this.rejectReason 
            }, true)
                .then(data => {
                    this.$message.success('审核驳回成功');
                    this.rejectDialogVisible = false;
                    this.selectedPeriod = null
                    this.fetchPeriods();
                })
                .catch(error => {
                    this.$message.error('驳回失败');
                });
        },
    },
  };
  </script>
  
  <style scoped>
  .declaration-management {
    padding: 10px;
  }
  .box-card {
    margin-bottom: 20px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/plus/compay/index/zq.vue